import { CEGEKA_ORGANIZATION_ID } from 'src/utils/permissions'

/**
 * @param theme
 * @return {boolean}
 */
export default function isCcpTheme(theme) {
    return theme?.name === 'ccp' || theme?.name === CEGEKA_ORGANIZATION_ID
}
